import _ from 'lodash';
import {
    FETCH_PROJECT,
    FETCH_PROJECTS,
    SEARCH_PROJECTS,
    RESET_PROJECTS,
} from '../actions/types';

const INITIAL_STATE: Object = null;

export default (state: Object = INITIAL_STATE, action: Object): Object => {
    switch (action.type) {
        case FETCH_PROJECTS:
        case SEARCH_PROJECTS:
            // overwrite the entire state
            return { ..._.mapKeys(action.payload, 'id') };
        case FETCH_PROJECT:
            return { ...state, [action.payload.id]: action.payload };
        case RESET_PROJECTS:
                return INITIAL_STATE;
        default:
            return state;
    }
};